<div class="grid">
    <div class="col-12 mb-2">
        <div class="card title-card p-0 pt-3">
            <div *ngIf="this.isMachineLoaded" class="flex flex-wrap justify-content-between pl-3 pr-3" role="toolbar">
                <div class="flex">
                    <div> <i class="pi pi-wifi title-card-icon"></i> </div>
                    <div>
                        <p class="mb-0 text-3xl title">
                            {{'model.machine' | transloco}} {{machine.serial}} ({{machine.organization.name}})</p>
                        <p *ngIf="machine.description"> {{machine.description}}</p>
                        <p *ngIf="!machine.description" class="font-italic">{{'empty.description' | transloco}}</p>
                    </div>
                </div>
                <p-button *ngIf="authGuard.hasPermission('PERMISSION_MANAGE_MACHINES') && !machine.deleted"
                          class="m-auto mr-0 mt-5 md:mt-2" icon="pi pi-pencil" label="{{ 'common.edit' | transloco }}"
                          (onClick)="this.navigateToMachineEdition()"></p-button>
            </div>

            <div *ngIf="!this.isMachineLoaded" class="flex flex-wrap justify-content-between pl-3 pr-3" role="toolbar">
                <div class="flex">
                    <div> <i class="pi pi-wifi title-card-icon"></i> </div>
                    <div>
                        <div class="lg:flex">
                            <div class="span w-15rem lg:ml-2 mt-2 lg:mt-0">
                                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                            </div>
                            <div class="span w-10rem lg:ml-2 mt-2 lg:mt-0">
                                <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                            </div>
                        </div>
                        <div class="span w-10rem ml-2 mt-2">
                            <p-skeleton width="100%" height="1.5rem"></p-skeleton>
                        </div>
                    </div>
                </div>
                <div class="span m-auto mr-0 mt-5 md:mt-2 w-7rem">
                    <p-skeleton width="100%" height="2.5rem"></p-skeleton>
                </div>
            </div>

            <div class="mt-2">
                <p-tabMenu [model]="menuItems" [activeItem]="activeMenuItem"></p-tabMenu>
            </div>
        </div>

        <div class="col-12 px-0 pt-0">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>
